import { useAssessmentStore } from "@/features/tutor/store/useAssessmentStore";
import { exitLesson } from "./endLesson";
import ASSESSMENT_TYPES, {
  isAssessmentSlideType,
} from "../constants/assessmentTypes";
import {
  showDynamicTutorViewNotification,
  NotificationType,
} from "@/store/useNotificationStore";
import {
  NOTIFICATION_STACKS,
  NotificationStackId,
} from "@/constants/notification";
import { getRemainingDuration } from "@/utils/audioUtils";

// +2: Next Bite opens the modal from the slide before the assessment.
export const getSlideIndexAfterAssessment = (slides, currentIndex) => {
  const slide = slides[currentIndex];
  const isOnAssessment = isAssessmentSlideType(
    slide?.metadata?.slide_type ?? slide?.slide_type,
  );
  const targetIndex = currentIndex + (isOnAssessment ? 1 : 2);
  return targetIndex < slides.length ? targetIndex : null;
};

export const handleAssessmentBeforeSlide = async (
  assessmentType,
  setActiveAssessmentModal,
  remainingDuration = null,
  { navigate, searchParams } = {},
) => {
  const config = ASSESSMENT_TYPES[assessmentType];
  if (!config) return;

  const hasAssessment =
    useAssessmentStore.getState().assessments[assessmentType]?.has;

  if (!hasAssessment) {
    if (assessmentType === "exit_ticket" && navigate) {
      exitLesson(navigate, searchParams);
    }
    return;
  }

  const delay =
    remainingDuration !== null ? remainingDuration : getRemainingDuration();

  setTimeout(async () => {
    const stackId = NotificationStackId.NEXT_SLIDE;
    const completed = await showDynamicTutorViewNotification(
      config.notification.title,
      { seconds: 3 },
      config.notification.subtitle,
      NotificationType.NEXT_BITE,
      3000,
      NOTIFICATION_STACKS[stackId],
    );
    if (completed) {
      setActiveAssessmentModal(assessmentType);
    }
  }, delay * 1000);
};
